/* Let's Mix — cart drawer: opens on add-to-bag / bag icon, ajax qty & remove, section re-render */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var busy = false;
  var lastFocus = null;

  function drawer() { return document.querySelector('[data-lm-drawer]'); }
  function sectionId() { var d = drawer(); return d ? d.getAttribute('data-section-id') : 'lm-cart-drawer'; }
  function isCartPage() { return /^\/cart\/?$/.test(location.pathname) || document.querySelector('[data-lm-cart]'); }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart-item-count-header--quantity, .cart-item-count-header, [data-cart-count], .site-header__cart-indicator').forEach(function (n) {
      n.textContent = count;
      n.classList.toggle('hide', !count);
    });
    var c = document.querySelector('.lm-drawer__count');
    if (c) c.textContent = count;
  }

  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lm-drawer-open');
    var panel = d.querySelector('.lm-drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lm-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function swap(html) {
    var d = drawer();
    if (!d || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-lm-drawer]');
    if (!fresh) return;
    var wasOpen = d.classList.contains('is-open');
    var panel = d.querySelector('.lm-drawer__body');
    var scrollTop = panel ? panel.scrollTop : 0;
    d.parentNode.replaceChild(fresh, d);
    if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
    var np = fresh.querySelector('.lm-drawer__body');
    if (np) np.scrollTop = scrollTop;
    updateHeaderCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    bind();
  }

  function rerender() {
    var id = sectionId();
    return fetch(root + '?sections=' + encodeURIComponent(id), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (json) { swap(json[id]); })
      .catch(function () {});
  }

  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (d) d.classList.toggle('is-busy', state);
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId()], sections_url: root })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (cart.sections && cart.sections[sectionId()]) { swap(cart.sections[sectionId()]); return; }
        return rerender();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { setBusy(false); });
  }

  function bind() {
    var d = drawer();
    if (!d || d.__lmBound) return;
    d.__lmBound = true;

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-lm-drawer-close]')) { e.preventDefault(); close(); var href = e.target.closest('a[href]'); if (href) window.location.href = href.href; return; }
      var lineEl = e.target.closest('[data-lm-line]');
      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute('data-lm-line'), 10);
      var input = lineEl.querySelector('[data-lm-qty-input]');
      if (e.target.closest('[data-lm-qty-minus]')) { e.preventDefault(); change(line, Math.max(0, parseInt(input.value, 10) - 1)); }
      else if (e.target.closest('[data-lm-qty-plus]')) { e.preventDefault(); change(line, parseInt(input.value, 10) + 1); }
      else if (e.target.closest('[data-lm-remove]')) { e.preventDefault(); lineEl.classList.add('is-removing'); change(line, 0); }
    });

    d.addEventListener('change', function (e) {
      var input = e.target.closest('[data-lm-qty-input]');
      if (!input) return;
      var lineEl = input.closest('[data-lm-line]');
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      change(parseInt(lineEl.getAttribute('data-lm-line'), 10), q);
    });
  }

  /* Header bag icons → open the drawer (except on the cart page itself) */
  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.site-header__cart-toggle, .site-nav--mobile a[href$="/cart"], a[data-lm-open-drawer]');
      if (!a || isCartPage() || !drawer()) return;
      e.preventDefault();
      rerender().then(open);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Anything added to the bag (quick add, product page) → refresh & open */
  document.addEventListener('lm:cart:added', function (e) {
    if (isCartPage()) return;
    var cart = e.detail;
    if (cart && typeof cart.item_count === 'number') updateHeaderCount(cart.item_count);
    rerender().then(open);
  });

  function init() { bind(); bindTriggers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
